module.exports = __webpack_public_path__ + "static/media/noun-993426-cc.f38ffb4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/noun-993426-cc.svg
// module id = 259
// module chunks = 0